import React, { useState, useEffect } from "react";
import Translations from '../../../services/translation.service';
import InvoiceIcon from "../../../assets/img/InvoiceOpen.svg";
import SharedAmountCurrency from "../../shared/sharedFields/amountWithCurrency";
import Helpers from "../../../helpers/shared.helper";
import CheckedImage from "../../../assets/img/CheckedImage.svg";
import UncheckedImage from "../../../assets/img/UncheckedImage.svg";
import ModalWrapperMid from "../../shared/modal-wrapper-mid";
import BillInvoice from "./bill-invoice";
import SharedAmount from "../../shared/sharedFields/amount";
import BillWalletIcon from "../../../assets/img/BillWallet.svg";
import FirebaseAnalytics from "../../../services/analytics.service";

const subscriptions = [];
const BillPaymentAccountRow = ({ account, selectedAccountCall, billCount, selectedAccounts }) => {
    const [openModal, setOpenModal] = useState(false);
    const [viewedInvoice, setViewedInvoice] = useState("");
    const [viewedMsisdn, setViewedMsisdn] = useState("");
    const [viewedNumberType, setViewedNumberType] = useState("");
    const [invoiceStatus, setInvoiceStatus] = useState("loading");
    const [translationKeys, setTranslationsKeys] = useState(
        Translations.keys ? Translations.keys : {}
    );

    const [amountFormValues, setAmountFormValues] = useState({
        submitLoader: false,
        amount: {
            value: account?.amount,
            touched: false,
            valid: true,
            error: "",
            validation: {
              required: true,
              minAmount: true,
              minAmountValue: account?.minAmount,
              maxAmount: true,
              maxAmountValue: account?.maxAmount,
            }
        }
      });
    
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
        if(account?.selected) {
            setNumberSelect(true);
        }
        if(billCount === 1) {
            setNumberSelect(true);
            selectedAccountCall({
                ...account,
                amount: amountFormValues.amount.value,
                valid: amountFormValues.amount.valid,
                selected: true
              });
        }
        subscriptions.push(
        Translations.getKeysObsrv().subscribe((data) => {
            setTranslationsKeys(data);
        })
        );

        return () => {
        if (subscriptions && subscriptions?.length) {
            for (let subscription of subscriptions) {
            subscription.unsubscribe();
            }
        }
        };
    }, []);  // eslint-disable-line react-hooks/exhaustive-deps

    
  const updateAmountInput = (amountObj) => {
    setAmountFormValues(prevState => ({
        ...prevState,
        amount: {
            ...prevState.amount,
            value: amountObj.value,
        }
    }));
  }

  const updateAmountField = (amountObj) => {
        const amountValue = Number(amountObj.value);
        setAmountFormValues(prevState => ({
        ...prevState,
        amount: {
            ...prevState.amount,
            value: amountValue,
            valid: amountObj.valid,
            touched: amountObj.touched,
            error: amountObj.error
        },
        }));
        if (numberSelect) {
            selectedAccountCall({
              ...account,
              amount: amountValue,
              valid: amountObj.valid,
              selected: true
            });
          }
    }
    const [numberSelect, setNumberSelect] = useState(false);
    // const renderErrorMsg = (errorMsg) => {
    //     // "Enter an amount between 25 SR and 2500 SR",
    //     // Please enter the amount you wish to pay.
    //     let parsedError = ""
    //     parsedError = Translations.keys[`stf_bill_payment_amount_enter_${errorMsg}`];
    
    //     return parsedError;
    //   }

    const renderErrorSingleMsg = (amt) => {
        const errorMsg = amt.error;
        const minErrorMsg = amt.validation.minAmountValue;
        const maxErrorMsg = amt.validation.maxAmountValue;
        // "Enter an amount between ${minErrorMsg} SR and ${maxErrorMsg} SR",
        // Please enter the amount you wish to pay.
        let parsedError = ""
        parsedError = Translations.keys[`stf_bill_payment_amount_enter_single_${errorMsg}`] || `${Translations.keys["stf_enter_amt_btw"] || "Enter an amount between"} ${minErrorMsg} ${Translations.keys["stm_general_currency"]} ${Translations.keys["stm_min_max_and"] || "and"} ${maxErrorMsg} ${Translations.keys["stm_general_currency"]}`;

        return parsedError;
    } 

    const renderStatus = (accStatus) => {
        // Terminated
        // Active
        // warn
        // suspended by administration
        // Suspended by Customer
        // Empty Status
        let textStatus = Translations.keys[`stf_account_status_${Helpers.formatStatusString(accStatus)}`] || accStatus;
        switch (accStatus) {
            case "Active":
            case "active":
                    return <div className="acc-status acc-status--active">{textStatus}</div>
            case "Terminated":
            case "terminated":
                    return <div className="acc-status acc-status--terminated">{textStatus}</div>
            case "warn":
                return <div className="acc-status acc-status--suspension">{textStatus}</div>
            case "suspended by administration":
            case "Suspended by administrator":
                return <div className="acc-status acc-status--suspension">{textStatus}</div>
            case "Suspended by Customer":
            case "suspended by Customer":
                return <div className="acc-status acc-status--suspension">{textStatus}</div>
            case "Empty Status":
            case "empty status":
                return <div className="acc-status acc-status--suspension">{textStatus}</div>
            default:
                return <div className="acc-status acc-status--suspension">{textStatus}</div>
        }
    }

    const handleModal = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setOpenModal((prev) => !prev);
      };
    
    const openInvoice = (e, invoice, msisdn, type) => {
        handleModal(e);
        const firebase_event_params = {
            event_category: 'bills',
            event_screen: 'bills_details',
            interaction_type: 'click',
            event_label: 'invoice',
            bill_number: invoice || '',
            due_amount: account?.dueAmount || '',
        }
        FirebaseAnalytics.commonFunction(firebase_event_params);
        setViewedInvoice(invoice);
        setViewedMsisdn(msisdn);
        setViewedNumberType(type);
    }

    const invoiceStatusState = (invoiceStatus) => {
        setInvoiceStatus(invoiceStatus);
        if(invoiceStatus === "failed"){
            setOpenModal(false)
        } 
    }
    
    const checkIfDisabled = (acc, selectedAcc) => {
        const isSelected = selectedAcc.some(item => 
            item.msisdn === acc.msisdn && item.selected === true
          );
        return !isSelected
    }

    return (
        billCount === 1 ? 
        <>
            <BillInvoice viewedInvoice={account?.receiptNumber} invoiceStatusState={invoiceStatusState} invoiceStatus={invoiceStatus} msisdn={account?.msisdn} numberType={account?.numberType}/>
            <div className="storefront-amount-field-container">
                <label>{translationKeys["stm_bill_payment_amt"]}</label>
                <div className="phone-field-with-tick amount-field-with-tick">
                    <SharedAmount
                        name="amount"
                        id="amount"
                        classname={`storefront-amount-field tickIcon walletIcon ${amountFormValues?.amount.error && !amountFormValues?.amount.valid ? "error-amt" : ""}`}
                        amount={amountFormValues?.amount}
                        updateAmountField={updateAmountField}
                        updateAmountInput={(e) => updateAmountInput(e)}
                        placeholder={translationKeys["stm_bill_payment_amount_placeholder"]}
                    />
                    <img src={BillWalletIcon} className="imgLeft" alt=""/>
                </div>
                {amountFormValues?.amount?.valid && !amountFormValues?.amount?.touched ?
                <div className="hint-section">
                {translationKeys["stf_bill_payment_amount_enter_required"] || "Please enter the amount you wish to pay."}
                </div> : ""}
                {amountFormValues?.amount.error && !amountFormValues?.amount.valid ? <span className="hint-section error-msg">{renderErrorSingleMsg(amountFormValues?.amount)}</span> : ""}
            </div>
        </>
        : 
        <>
        <div className="bill-payment-account-list-conatiner">
            <div className="bill-payment-account-list">
                <div>
                    <span className="bill-payment-column-head">{translationKeys["stm_bill_payment_postpaid_acc"] || "Postpaid accounts"}</span>
                    <div className="bill-payment-account-conatiner">
                        <div className="bill-payment-account-detail">
                            <div>
                                <img
                                className="checkbox-image"
                                src={numberSelect ? CheckedImage : UncheckedImage}
                                alt="Checkbox"
                                onClick={()=>{
                                    const newSelected = !numberSelect;
                                    setNumberSelect(newSelected);
                                  
                                    selectedAccountCall({
                                      ...account,
                                      amount: amountFormValues.amount.value,
                                      valid: amountFormValues.amount.valid,
                                      selected: newSelected
                                    });
                                    
                                }}
                                />
                            </div>
                            <div>
                                <div>{Helpers.formatNumberJS(account?.msisdn)}</div>
                                <div>{translationKeys["stm_bill_payment_postpaid_due_amt"] || "Due Amount"}{" "}<span>{Helpers.renderCurrencySymbolWithPrice(Helpers.formatWithPORemoveCommas(account?.dueAmount), "SR")}</span></div>
                            </div>
                        </div>
                        <div className="bill-payment-account-status">
                            {renderStatus(account?.status)}
                            <div>{account?.status !== "Active" ? `${translationKeys["stm_bill_date"] || "Date:"} ${account?.statusDate}` : `${translationKeys["stm_bill_due_date"] || "Bill due to"} ${account?.statusDate}`}</div>
                        </div>
                    </div>
                </div>
                <div>
                    <div className="bill-payment-column-head">
                        <div>{translationKeys["stm_bill_payment_amount"] || "Payment Amount"}</div>
                        <span>{translationKeys["stm_bill_payment_vat_inc"] || "(VAT included)"}</span>
                    </div>
                    <div>
                        <div className="storefront-amount-field-container">
                            <div className={`phone-field-with-tick amount-field-with-tick ${checkIfDisabled(account, selectedAccounts) ? "amount-is-disabled" : "amount-is-enabled"}`}>
                                <SharedAmountCurrency
                                    name="amount"
                                    id="amount"
                                    classname={`storefront-amount-field tickIcon walletIcon ${amountFormValues?.amount.error && !amountFormValues?.amount.valid ? "error-amt" : ""}`}
                                    amount={amountFormValues?.amount}
                                    updateAmountField={updateAmountField}
                                    updateAmountInput={(e) => updateAmountInput(e)}
                                    placeholder={translationKeys["stm_bill_payment_amount_placeholder"]}
                                    showCurrencyInside={false}
                                    amountDisabled={checkIfDisabled(account, selectedAccounts)}
                                />
                                <div className={`textIconLeft ${amountFormValues?.amount?.touched || amountFormValues?.amount?.value > 0 ? "currency-amount-touched" : "currency-amount-untouched"} `}>{Helpers.renderCurrencySymbolReplace("SR")}</div>
                            </div>
                            {/* {amountFormValues?.amount.error && !amountFormValues?.amount.valid ? <span className="hint-section error-msg">{renderErrorMsg(amountFormValues?.amount.error)}</span> : ""} */}
                        </div>
                        <div className="bill-payment-view-invoice-icon" onClick={(e) => openInvoice(e, account?.receiptNumber, account?.msisdn, account?.numberType)}>
                            <img src={InvoiceIcon} alt="" data-id={account?.receiptNumber}/>
                        </div>
                    </div>
                </div>
            </div>
            {amountFormValues?.amount.error && !amountFormValues?.amount.valid ? <span className="error-msg">{renderErrorSingleMsg(amountFormValues?.amount)}</span> : ""}
        </div>
        {openModal && 
            <ModalWrapperMid handleToggleModal={handleModal}>
                <div className="progress-prompt-modal storefront-modal-over-modal">
                    <span>{translationKeys["stm_bill_dtl"] || "Bill details"}</span>
                    <p>{translationKeys["stm_bill_dtl_desc"] || "A breakdown of charges, due dates, and payment status."}</p>
                    <BillInvoice viewedInvoice={viewedInvoice} invoiceStatusState={invoiceStatusState} invoiceStatus={invoiceStatus} msisdn={viewedMsisdn} numberType={viewedNumberType}/>
                    {invoiceStatus === "success" ?
                        <button className={"common-button"} onClick={handleModal}>{translationKeys["stf_close"]}</button>
                    : "" }
                </div>
            </ModalWrapperMid>
        }            
        </>
    )
}
export default BillPaymentAccountRow;